module.exports = __webpack_public_path__ + "static/media/13.Concrete Cutter.6eb66530.jpg";